import { DRAWING_DASH_GAP_RATIO, DRAWING_DASH_LENGTH_RATIO } from "./drawingConstants";

// The part of the segment inside the pane, as shares of its length
const visibleRange = ([x0, y0, x1, y1], { width, height }) => {
  let start = 0;
  let end = 1;

  [
    [-(x1 - x0), x0],
    [x1 - x0, width - x0],
    [-(y1 - y0), y0],
    [y1 - y0, height - y0],
  ].forEach(([direction, room]) => {
    if (direction === 0) {
      if (room < 0) end = -1;
    } else if (direction < 0) start = Math.max(start, room / direction);
    else end = Math.min(end, room / direction);
  });

  return start < end ? [start, end] : null;
};

/**
 * A dashed line as short segments for the line renderer, so WebGL and its
 * Canvas 2D version draw the same dashes. Only the part in the pane is cut, and
 * the dashes are counted from the start of the line, so they do not swim when
 * it goes over the pane edge; a long line under a big zoom stays a few segments.
 *
 * @param {number[]} segment - [x0, y0, x1, y1], CSS px of the pane
 * @param {{ width: number, height: number }} pane
 * @param {number} lineWidth - CSS px: thick lines get long dashes, their caps would close short gaps
 * @returns {number[][]} segments
 */
export const dashSegment = (segment, pane, lineWidth) => {
  const [x0, y0, x1, y1] = segment;
  const length = Math.hypot(x1 - x0, y1 - y0);
  const range = visibleRange(segment, pane);

  if (!length || !range) return [];

  const dashLength = DRAWING_DASH_LENGTH_RATIO * lineWidth;
  const period = dashLength + DRAWING_DASH_GAP_RATIO * lineWidth;
  const visibleEnd = range[1] * length;
  const pointAt = (distance) => [x0 + ((x1 - x0) * distance) / length, y0 + ((y1 - y0) * distance) / length];
  const dashes = [];

  for (let from = Math.floor((range[0] * length) / period) * period; from < visibleEnd; from += period) {
    dashes.push([...pointAt(from), ...pointAt(Math.min(from + dashLength, length))]);
  }

  return dashes;
};
